import Vuex from 'vuex';

const getters: any = {
    device: (state: { app: { device: string; }; }) => state.app.device,
    token: (state: { app: { token: string; }; }) => state.app.token, // 登录的 token
    height: (state: { app: { height: number; }; }) => state.app.height, // 网页高度
    infoType: (state: { app: { infoType: number; }; }) => state.app.infoType,
    infoDesc: (state: { app: { infoDesc: string; }; }) => state.app.infoDesc,
    infoUrl: (state: { app: { infoUrl: string; }; }) => state.app.infoUrl,
    fission: (state: { app: { fission: number; }; }) => state.app.fission,
    merchant: (state: { app: { merchant: number; }; }) => state.app.merchant,
}

export default getters;